import { Row, Tooltip, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { SolidInformationCircleIcon } from '@tempmee/react-icons';

export const Title = () => (
  <Row>
    <Typography as="span" bold size="body_large">
      Invite:&nbsp;
      <Typography as="span" color={colors.neutral[500]}>(Optional)</Typography>
    </Typography>
    <Tooltip
      content="Please note, invites will not be delivered to candidates on requested dates in which they are unavailable."
      placement="bottom"
    >
      <SolidInformationCircleIcon color={colors.neutral[300]} />
    </Tooltip>
  </Row>
);
